import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;
                text-transform: capitalize;

                @media (max-width: 768px) {
                    font-size: 2.5em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;
        
        a, span {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            text-transform: capitalize;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1000px;
        margin: -40px auto 0;
        padding: 0 20px;
        position: relative;
        z-index: 10;
        
        .info-container {
            background: white;
            border-radius: 24px;
            padding: 50px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0,0,0,0.04);
            margin-bottom: 40px;

            @media (max-width: 768px) {
                padding: 30px 20px;
            }

            .text-content {
                h3 {
                    color: #00A9C4;
                    font-size: 1.8em;
                    margin: 20px 0 15px;
                    font-weight: 700;
                    line-height: 1.4;

                    &:first-child {
                        margin-top: 0;
                    }

                    @media (max-width: 768px) {
                        font-size: 1.35em;
                    }
                }

                article {
                    font-size: 1.15em;
                    line-height: 1.6;
                    color: #334155;
                    margin-bottom: 20px;
                    display: block;

                    @media (max-width: 768px) {
                        font-size: 1em;
                    }
                }

                p {
                    font-size: 1.15em;
                    line-height: 1.8;
                    color: #334155;
                    margin-bottom: 20px;
                    text-align: justify;

                    @media (max-width: 768px) {
                        font-size: 1em;
                        text-align: left;
                    }
                }
            }

            .slider-wrapper {
                margin-top: 50px;
                margin-bottom: 20px;
                border-radius: 16px;
                padding: 20px;
                background: #f8fafc;
                box-shadow: inset 0 2px 10px rgba(0,0,0,0.02);

                .slick-slider {
                    width: 100%;
                }
                
                .slick-slide {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                }

                img {
                    width: auto;
                    max-width: 100%;
                    max-height: 500px;
                    border-radius: 12px;
                    object-fit: contain;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
                    cursor: pointer;
                    transition: transform 0.3s ease;
                    margin: 0 auto;
                    
                    &:hover {
                        transform: scale(1.02);
                    }
                }

                .custom-paging {
                    bottom: -60px;
                }
                
                .slick-dots {
                    margin-top: 20px;
                    
                    li {
                        width: 60px;
                        height: 60px;
                        margin: 0 5px;
                        
                        a {
                            width: 100%;
                            height: 100%;
                            display: block;
                        }
                        
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            border-radius: 8px;
                            box-shadow: none;
                            opacity: 0.6;
                            transition: opacity 0.3s ease;
                            cursor: pointer;
                        }
                        
                        &.slick-active img {
                            opacity: 1;
                            border: 2px solid #00A9C4;
                        }
                    }
                }
            }
        }
    `
};

export default S;